var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfinite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 12,
    viewBox: "0 0 26 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79877 -1.41301e-07C7.28452 -2.7119e-07 8.77028 0.585435 9.90139 1.75559L11.4959 3.40513C11.773 3.69176 11.773 4.15609 11.4959 4.44272C11.2188 4.72935 10.77 4.72935 10.4929 4.44272L8.89842 2.79318C7.18894 1.02541 4.4086 1.02469 2.69912 2.79247C0.991023 4.56095 0.991024 7.43762 2.69912 9.20575C4.4086 10.9728 7.18894 10.9742 8.89842 9.20646L16.0986 1.75631C18.3605 -0.584004 22.042 -0.584004 24.3039 1.75631C26.5654 4.09662 26.5654 7.90446 24.3039 10.2448C22.0416 12.5851 18.3608 12.5851 16.0986 10.2448L14.5041 8.59523C14.227 8.3086 14.227 7.84427 14.5041 7.55764C14.7812 7.27101 15.23 7.27101 15.5071 7.55764L17.1016 9.20718C18.8111 10.975 21.5914 10.975 23.3009 9.20718C25.0093 7.43905 25.0093 4.56239 23.3009 2.7939C21.5921 1.02541 18.8111 1.02541 17.1016 2.7939L9.90139 10.2441C7.63917 12.5836 3.95837 12.5836 1.69615 10.2433C-0.565382 7.90303 -0.565383 4.09519 1.69615 1.75487C2.82726 0.585436 4.31302 -1.14124e-08 5.79877 -1.41301e-07Z",
    fill: "url(#paint0_linear_623_3604)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_3604",
    x1: 26,
    y1: 9,
    x2: 2.0643,
    y2: 3.23771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B7C4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinite);
export default __webpack_public_path__ + "static/media/infinite.a743aa2d542de9c8d04c794890992738.svg";
export { ForwardRef as ReactComponent };